function updateUrlParameter(url, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = url.indexOf("?") === -1 ? "?" : "&";

  if (url.match(re)) {
    return url.replace(re, "$1" + key + "=" + value + "$2");
  } else {
    return url + separator + key + "=" + value;
  }
}

const fetchProductCard = (productHandle, referrer) => {
  const productTileTemplateUrl = referrer ? `/products/${productHandle}/${referrer}?view=card` : `/products/${productHandle}?view=card`;
  return fetch(productTileTemplateUrl)
    .then((res) => res.text())
    .then((res) => {
      const text = res;
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, "text/html");
      const productCard = htmlDocument.documentElement.querySelector('.product-card');
      return productCard?.outerHTML;
    });
};

async function subscribeRestockAlert(variantId, email) {
  await fetch(
    "https://thecubicle-receiver.azurewebsites.net/alerts/restock/" +
      variantId +
      "?email=" +
      email,
    {
      method: "post",
    }
  );
}

function addToCartAsync(
  variantId,
  quantity = 1,
  isPreorder,
  isBackorder,
  properties,
  callback
) {
  let allProperties = {
    ...properties,
    ...{ _src: (location.pathname + location.search).substr(1) },
  };

  if (isPreorder) {
    allProperties["Pre-Order"] =
      "Not available for immediate shipment — check product page for shipment estimates. If there are other items in your cart, consider ordering them separately. Your order will only ship when all items are available.";
  } else if (isBackorder) {
    allProperties["Back-Order"] =
      "The selected item is unavailable right now but we expect it to be available again soon. If there are other items in your cart, consider ordering them separately. Your order will only ship when all items are available.";
  }
  const body = {
    items: [
      {
        id: variantId,
        quantity: quantity,
        properties: allProperties,
      },
    ]
  };

  const options = {
    firstCallback: function (requestState) {
      if (!requestState.responseData.ok) {
        alert(requestState.responseData.body.message);
      }
      callback();
    },
    info: {},
  };
  liquidAjaxCart.add(body, options);
}

function addBatchToCartAsync(variants, callback) {
  var batchItems = { items: [] };

  for (let v of variants) {
    let allProperties = {
      ...v.properties,
      ...{ _src: (location.pathname + location.search).substr(1) },
    };

    if (v.isPreorder) {
      allProperties["Pre-Order"] =
        "Not available for immediate shipment — check product page for shipment estimates. If there are other items in your cart you want to ship sooner, consider ordering them separately. Your order will only ship when all items are available.";
    } else if (v.isBackorder) {
      allProperties["Back-Order"] =
        "The selected item is unavailable right now but we expect it to be available again soon. If there are other items in your cart you want to ship sooner, consider ordering them separately. Your order will only ship when all items are available.";
    }
    batchItems.items.push({
      id: v.variantId,
      quantity: v.quantity,
      name: v.variantId,
      properties: allProperties,
    });
  }

  const options = {
    firstCallback: function (requestState) {
      callback();
    },
    info: {},
  };
  liquidAjaxCart.add(batchItems, options);
}
document.addEventListener("alpine:init", () => {
  
  Alpine.store("queryParams", {
    value: new URLSearchParams(location.search),
    get(key) {
      return this.value.get(key);
    },
    set(key, value) {
      const url = new URL(window.location);
      url.searchParams.set(key, value);
      history.pushState(null, "", url);
    },
    init() {},
  });

  Alpine.store("cart", {
    count: 0,
    init() {
      let initialState = JSON.parse(document.querySelector('#cart-initial-state').innerHTML);
      this.count = initialState.item_count;
      document.addEventListener('liquid-ajax-cart:request-end', (event) => {
        if (event.detail.cart) {
          this.count = event.detail.cart.item_count;
        }
      });
    },
  });

  Alpine.store("windowSize", {
    width: 0,
    height: 0,
    get isMobile() {
      return this.width < 480;
    },
    init() {
      
    },
  });

  Alpine.store("notifications", {
    unseenCount: 0,
    init() {
      
    },
  });


  Alpine.store("modal", {
    isOpen: false,
    contentId: null,
    openModal(contentId) {   
      //document.body.style.top = `-${window.scrollY}px`;
      //document.body.style.position = 'fixed';
      this.isOpen = true;
      if (contentId) this.contentId = contentId;   
    },
    closeModal () {     
      const scrollY = document.body.style.top; 
      //document.body.style.top = '';
      //document.body.style.position = '';
      this.isOpen = false;
      //window.scrollTo({top: parseInt(scrollY || '0') * -1, behavior: 'instant'});
    },
    toggleModal(contentId) {
      if (this.isOpen) {
        this.closeModal();
      }
      else {
        this.openModal(contentId);
      }
    },
    init() {

    }
  });

  
  Alpine.store("customer", {
    id: null,
    email: null,
    firstName: null,
    get isLoggedIn() {
      return this.id != null;
    },
    init() {
      let el = document.querySelector("#customer-data");
      if (el) {
        let customer = JSON.parse(el.text);
        this.id = customer.id;
        this.email = customer.email;
        this.firstName = customer.firstName;
      }
    },
  });



  
  Alpine.data("global", () => ({
    global: {
      loading: false
    },
    get isLoggedIn() {
      return true;
      return this.$store.customer.isLoggedIn;
    },
    decodeHtmlEntities(str) {
      return str
          .replace(/&amp;/g, '&')       // Replace &amp; with &
          .replace(/&lt;/g, '<')         // Replace &lt; with <
          .replace(/&gt;/g, '>')         // Replace &gt; with >
          .replace(/&quot;/g, '"')       // Replace &quot; with "
          .replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(dec)) // Decode &#123; format
          .replace(/&#x([a-fA-F0-9]+);/g, (match, hex) => String.fromCharCode(parseInt(hex, 16))); //     
    }
  }));
  

  Alpine.data("cartModal", () => ({
    cartModal: {
      showSpecialRequests: false,
      justAddedMode: false,
      hideContents: false,
      justAddedShownVariantIds: []
    },
    cartManualOpen: {
      ['@cart-manual-open.window']() {
        this.cartModal.justAddedMode = false;
        this.$store.modal.openModal('cart-content-modal');
      }
    },
    init() {
      this.$watch('$store.modal.isOpen', (isOpen) => {
        if (!isOpen) {
          this.cartModal.justAddedMode = false;
        }
      });

      document.addEventListener('liquid-ajax-cart:request-start', (event) => {
        if (event.detail.requestState.requestType == 'add') {
          this.cartModal.justAddedShownVariantIds = event.detail.requestState.requestBody.items.map(x => x.id);
          this.cartModal.hideContents = true;
          this.$store.modal.openModal('cart-content-modal');
        }
      });

      document.addEventListener('liquid-ajax-cart:request-end', (event) => {
        if (event.detail.requestState.requestType == 'add') {
            this.cartModal.hideContents = false;
            this.cartModal.justAddedMode = true;      
        }
      });


    },
  }));



  Alpine.data("product", () => ({
    product: null,
    selectedVariant: null,
    isAddingToCart: false,
    isSubscribingRestockAlert: false,
    lubeServiceSelected: false,
    restockAlertSuccess: false,
    isInitializing: true,
    includeCubeheadLubeBundle: false,
    lineItemProperties: {},
    dirty: false,
    quantity: 1,
    volumeDiscount: null,
    volumeDiscountSavedAmount: "\u00A0",
    addons: [],
    init() {
      // this.$store.stickyAddToCart.show = true;
      let data = JSON.parse(this.$refs.data.text);
      this.volumeDiscount = this.$refs.volumeDiscount ? JSON.parse(this.$refs.volumeDiscount.text) : null;
      this.product = data.product;
      let variantMeta = data.variantMeta;
      for (let v of this.product.variants) {
        let matchingMeta = variantMeta.find((x) => x.id == v.id);
        v.isPreorder = matchingMeta.isPreorder;
        v.isBackorder = matchingMeta.isBackorder;
      }
      this.selectedVariant = this.product.variants.find(
        (x) => x.id == data.initialSelectedVariant
      );
      this.lubeServiceSelected =
        this.selectedVariant.option1.includes(" [+Lube Service]");
      this.$watch("lubeServiceSelected", (value) => {
        let option = this.selectedVariant.option1;

        if (value) {
          this.selectedVariant = this.product.variants.find(
            (x) => x.option1 == option + " [+Lube Service]"
          );
        } else {
          this.selectedVariant = this.product.variants.find(
            (x) => x.option1 == option.replace(" [+Lube Service]", "")
          );
        }
      });
      this.$watch("selectedVariant", (value) => {
        this.dirty = true;
        if (this.volumeDiscount) {       
          if (this.quantity < 2) {
            this.volumeDiscountSavedAmount = "\u00A0";
          }
          else {
            this.volumeDiscountSavedAmount = this.calculateSavedAmount(this.volumeDiscount, this.selectedVariant.price, this.quantity);
          }

        }
      });
      this.$watch("quantity", (value) => {
        if (this.volumeDiscount) {
          if (value < 2) {
            this.volumeDiscountSavedAmount = "\u00A0";
          }
          else {
            this.volumeDiscountSavedAmount = this.calculateSavedAmount(this.volumeDiscount, this.selectedVariant.price, this.quantity);
          }

        }
      });
    },
    calculateSavedAmount(discounts, priceCents, quantity) {
      let applicableDiscount = 0;
    
      // Sort discounts in descending order of minQuantity to find the highest applicable discount
      const sortedDiscounts = discounts.slice().sort((a, b) => b.minQuantity - a.minQuantity);
      
      for (const discount of sortedDiscounts) {
          if (quantity >= discount.minQuantity) {
              applicableDiscount = discount.discountPercent;
              break;
          }
      }
  
      const total = priceCents * quantity;
      const discountCents = (total * applicableDiscount) / 100;
      const discountDollars = discountCents / 100;
  
      // Format to two decimal places and return the string
      return `You saved ${applicableDiscount}% ($${discountDollars.toFixed(2)})!`;
    },
    showSelectedVariantsLubeServiceOption() {
      if (this.selectedVariant.inventory_quantity <= 0) return false;
      if (this.lubeServiceSelected) return true;
      if (this.selectedVariant.title.includes("[+Lube Service]")) return true;
      let lubeServiceVariant = this.product.variants.find(
        (x) => x.sku == `c${this.selectedVariant.sku}`
      );
      if (!lubeServiceVariant) return false;
      //return lubeServiceVariant.inventory_quantity > 0;
      return lubeServiceVariant?.available;
    },
    resetLineItemProperties() {
      this.lineItemProperties = {};
    },
    onVariantSelected(event) {
      if (this.isInitializing) {
        this.isInitializing = false;
        return;
      }
      let variant = event.detail;
      this.selectedVariant = variant;
      const url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState(null, "", url.toString());
    },
    onAddonsChanged(event) {
      let addon = event.detail;
      let match = this.addons.find(x => x.productId == addon.productId);
      if (match) {
        match.variantId = addon.variantId;
        match.isSelected = addon.isSelected;
        match.isBackorder = addon.isBackorder;
        match.isPreorder = addon.isPreorder;
      }
      else {
        this.addons.push(addon);
      }
      this.addons = this.addons.filter(x => x.isSelected);
    },
    onAddToCartButtonClick: {
      ["@click.prevent"]() {
        this.handleAddToCartClick();
      },
    },
    handleAddToCartClick() {
      this.isAddingToCart = true;
      if (this.includeCubeheadLubeBundle) {
        let payload = [
          {
            variantId: this.selectedVariant.id,
            quantity: this.quantity,
            isPreorder: this.selectedVariant.isPreorder,
            isBackorder: this.selectedVariant.isBackorder,
            properties: {},
          },
          {
            variantId: 39453028614227,
            quantity: 1,
            properties: {
              Bundle: "Yoo Lube Bundle",
              _BundleItems:
                "6669364297811,6669364232275,6613035548755,6613035778131",
              _BundleTier: "4",
              _BundleCode: "29101",
            },
          },
          {
            variantId: 39453028483155,
            quantity: 1,
            properties: {
              Bundle: "Yoo Lube Bundle",
              _BundleItems:
                "6669364297811,6669364232275,6613035548755,6613035778131",
              _BundleTier: "4",
              _BundleCode: "29101",
            },
          },
          {
            variantId: 39591496745043,
            quantity: 1,
            properties: {
              Bundle: "Yoo Lube Bundle",
              _BundleItems:
                "6669364297811,6669364232275,6613035548755,6613035778131",
              _BundleTier: "4",
              _BundleCode: "29101",
            },
          },
          {
            variantId: 39591496679507,
            quantity: 1,
            properties: {
              Bundle: "Yoo Lube Bundle",
              _BundleItems:
                "6669364297811,6669364232275,6613035548755,6613035778131",
              _BundleTier: "4",
              _BundleCode: "29101",
            },
          },
        ];
        addBatchToCartAsync(payload, () => {
          this.isAddingToCart = false;
        });
      }
      else if (this.addons.length) {
        let payload = [         
          ...this.addons.map(x => ({
            variantId: x.variantId,
            quantity: this.quantity,
            isPreorder: x.isPreorder,
            isBackorder: x.isBackorder,
            properties: {
              _Addon: this.selectedVariant.id
            }
          })),
          {
            variantId: this.selectedVariant.id,
            quantity: this.quantity,
            isPreorder: this.selectedVariant.isPreorder,
            isBackorder: this.selectedVariant.isBackorder,
            properties: {},
          },
        ];
        addBatchToCartAsync(payload, () => {
          this.isAddingToCart = false;
        });   
      } else {
        addToCartAsync(
          this.selectedVariant.id,
          this.quantity,
          this.selectedVariant.isPreorder,
          this.selectedVariant.isBackorder,
          this.lineItemProperties,
          () => {
            this.isAddingToCart = false;
          }
        );
      }
    },
    async onRestockAlertButtonClick(href) {
      this.isSubscribingRestockAlert = true;
      let email = this.$store.customer?.email;
      if (email) {
        await subscribeRestockAlert(this.selectedVariant.id, email);
        this.isSubscribingRestockAlert = false;
        this.restockAlertSuccess = true;
      } else {
        window.location.href = href;
      }
    },
  }));

  Alpine.data("swatch", () => ({
    //should have access to complete product object
    selectedOptions: [
      { name: null, value: null },
      { name: null, value: null },
      { name: null, value: null },
    ],
    isInitialDataSync: false,
    variantSelected() {
      let matchingVariant = this.product.variants.find(
        (x) =>
          x.options[0] == this.selectedOptions[0].value &&
          x.options[1] == this.selectedOptions[1].value &&
          x.options[2] == this.selectedOptions[2].value
      );
      this.$dispatch("variant-selected", matchingVariant);
    },
    init() {
      this.$watch("selectedVariant", (variant) => {
        //this is triggered when the variant is programmatically selected. this does not trigger .change().
        if (!variant.options) return;
        for (let i = 0; i < variant.options.length; i++) {
          let o = variant.options[i];
          if (o) {
            this.selectedOptions[i].value = o;
          }
        }
      });
      this.$watch("selectedOptions", (value) => {
        this.variantSelected();
      }),
        this.initialDataSync();
    },
    initialDataSync() {
      // this should only be run once to sync DOM selections rendered on the server with local data.
      let checked = this.$el.querySelectorAll("input:checked");
      this.isInitialDataSync;
      for (let o of checked) {
        let index = o.getAttribute("x-data-option-index");
        let name = o.getAttribute("x-data-option-name");
        let value = o.value;
        this.isInitialDataSync = true;
        this.selectedOptions[index] = {
          name: name,
          value: value,
        };
      }
    },
  }));

  Alpine.data("cubicleCustom", () => ({
    default: "Default",
    cubicleCustomOptions: null,
    cubicleCustomPresets: null,
    additionalRequests: null,
    selectedOptions: [],
    effect: {
      ["x-effect"]() {
        this.resetLineItemProperties();
        let lineItemProperties = {
          _Custom: "Yes",
          Additional: this.additionalRequests,
        };
        for (let j = 0; j < this.selectedOptions.length; j++) {
          if (!this.shouldDisplay(j)) continue;
          let s = this.selectedOptions[j];
          
          for (let i = 0; i < s.selections.length; i++) {
            let propertyKey = s.name.split("-")[0];
            if (s.selections.length > 1) {
              propertyKey += " " + (i + 1);
            }
            let propertyValue = s.selections[i];
            lineItemProperties[propertyKey] = propertyValue.split(" (")[0];
          }
        }
        this.lineItemProperties = {
          ...this.lineItemProperties,
          ...lineItemProperties,
        };
      },
    },
    init() {
      let parsed = JSON.parse(this.$refs.data.text);
      this.cubicleCustomOptions = parsed.options;
      this.cubicleCustomPresets = parsed.presets;
      this.default = parsed.default;
      this.$watch("selectedOptions", (value) => {});
      this.initialDataSync();
    },
    generateJSON() {
      let json = JSON.stringify(this.selectedOptions);
    },
    shouldDisplay(optionIndex) {
      let variantTitle = this.selectedVariant.title;
      let isBlackSideVariant = variantTitle == "Stickerless / Black Side";

      let optionName = this.cubicleCustomOptions[optionIndex].name;
      let isBlackSideSpecificOption = optionName.includes("BlackSide");

      if (optionName.includes("Replace With Black") && !isBlackSideVariant)
        return false;
      if (
        optionName.includes("Color Scheme") &&
        isBlackSideSpecificOption &&
        !isBlackSideVariant
      )
        return false;
      if (
        optionName.includes("Color Scheme") &&
        !isBlackSideSpecificOption &&
        isBlackSideVariant
      )
        return false;
      return true;
    },
    initialDataSync() {
      let defaultSetup = this.default;

      if (!defaultSetup) {
        defaultSetup = "Default";
      }
      let defaults = this.cubicleCustomPresets.find(
        (x) => x.name == defaultSetup
      ).options;
      this.selectedOptions = defaults;
    },
  }));

  Alpine.data("stickerSets", () => ({
    selectedVariantId: null,
    customProperties: null,
    stickers: [null, null, null, null, null, null, null, null],
    isInitialDataSync: false,
    variantSelected() {
      let matchingVariant = this.product.variants.find(
        (x) => x.id == Number(this.selectedVariantId)
      );
      this.$dispatch("variant-selected", matchingVariant);
    },
    init() {
      this.$watch("selectedVariantId", (value) => {
        this.variantSelected();
      }),
        this.initialDataSync();
    },
    effect: {
      ["x-effect"]() {
        this.resetLineItemProperties();
        if (this.selectedVariant.title.includes("Custom")) {
          let lineItemProperties = {
            "Custom Stickers": this.stickers.filter((x) => x).join(", "),
            "_Sticker 1": this.stickers[0],
            "_Sticker 2": this.stickers[1],
            "_Sticker 3": this.stickers[2],
            "_Sticker 4": this.stickers[3],
            "_Sticker 5": this.stickers[4],
            "_Sticker 6": this.stickers[5],
            "_Sticker 7": this.stickers[6],
            "_Sticker 8": this.stickers[7],
          };
          this.lineItemProperties = {
            ...this.lineItemProperties,
            ...lineItemProperties,
          };
        }
      },
    },
    initialDataSync() {
      // this should only be run once to sync DOM selections rendered on the server with local data.
      let checked = this.$el.querySelector("input:checked");
      this.selectedVariantId = checked.value;

      let s1 = this.$refs['sticker-1'];
      if (s1) this.stickers[0] = s1.value;
      let s2 = this.$refs['sticker-2'];
      if (s2) this.stickers[1] = s2.value;
      let s3 = this.$refs['sticker-3'];
      if (s3) this.stickers[2] = s3.value;
      let s4 = this.$refs['sticker-4'];
      if (s4) this.stickers[3] = s4.value;
      let s5 = this.$refs['sticker-5'];
      if (s5) this.stickers[4] = s5.value;
      let s6 = this.$refs['sticker-6'];
      if (s6) this.stickers[5] = s6.value;
      let s7 = this.$refs['sticker-7'];
      if (s7) this.stickers[6] = s7.value;
      let s8 = this.$refs['sticker-8'];
      if (s8) this.stickers[7] = s8.value;
    },
  }));

  Alpine.data("addonProductTile", () => ({
    addonProductTile: {
      product: null,
      selectedVariantId: null,
      isSelected: false, 
      get selectedVariant() {
        return {
          ...this.product.variants.find((x) => x.id == this.selectedVariantId)
        };
      }     
    },
    init() {
      let data = JSON.parse(this.$refs.data.text);
      this.addonProductTile.product = data.product;

      let historySelectedVariantId = this.$refs.selectedVariantId;
      let historyIsSelected = this.$refs.isSelected;

      this.addonProductTile.selectedVariantId = this.addonProductTile.product.variants.find(
        (x) => x.isDefault
      ).id;

      window.addEventListener('pageshow', () => {
        if (historySelectedVariantId && Number(historySelectedVariantId.value) !== this.addonProductTile.selectedVariantId) {
          this.addonProductTile.selectedVariantId = Number(historySelectedVariantId.value);
        }
        if (historyIsSelected?.checked) {
          this.addonProductTile.isSelected = true;
        }
      });


      this.$watch("addonProductTile.selectedVariantId", (value) => {
        this.dispatch();
      });
      this.$watch("addonProductTile.isSelected", (value) => {
        this.dispatch();
      });
    },
    dispatch() {
      this.$dispatch("addons-changed", { 
          productId: Number(this.addonProductTile.product.id),
          variantId: Number(this.addonProductTile.selectedVariantId),
          isSelected: this.addonProductTile.isSelected,
          isBackorder: this.addonProductTile.selectedVariant.isBackorder,
          isPreorder: this.addonProductTile.selectedVariant.isPreorder
      });
    }
  }));


  //could be a child of collection, product, or bundleProduct
  Alpine.data("productCard", () => ({
    product: null,
    selectedVariantId: null,
    get selectedVariant() {
      return {
        ...this.product.variants.find((x) => x.id == this.selectedVariantId),
        product: this.product,
      };
    },
    get display () {
      if (!this.myWishlist?.productCardHideList || !this.myWishlist.productCardHideList.includes(this.product.id)) return true;
      return false;
    },
    isAddingToCart: false,
    variantManuallySelected: false,
    dirty: false,
    get shownImageId() {
      if (!this.dirty) return null;
      return this.selectedVariant.featured_image?.id;
    },
    get showMainImage() {
      if (!this.dirty) return true;
      return this.shownImageId == null;
    },
    init() {
      let data = JSON.parse(this.$refs.data.text);
      this.product = data.product;

      this.selectedVariantId = this.product.variants.find(
        (x) => x.isDefault
      ).id;

      this.$nextTick(() => {
        this.$dispatch("variant-selected-from-bundle", this.selectedVariant);
      });

      this.$watch("selectedVariantId", (value) => {
        this.dirty = true;
        this.$dispatch("variant-selected-from-bundle", this.selectedVariant);
      });
    },
    onAddToCartButtonClick: {
      ["@click.prevent"]() {
        this.isAddingToCart = true;
        addToCartAsync(
          this.selectedVariant.id,
          1,
          this.selectedVariant.isPreorder,
          this.selectedVariant.isBackorder,
          {},
          () => {
            this.isAddingToCart = false;
          }
        );
      },
    },
  }));

  Alpine.data("productCardSwatchSelect", () => ({
    // selectedVariantDetail: "{}",
    // propagateData() {
    //   let parsed = JSON.parse(this.selectedVariantDetail);
    //   this.selectedVariant = parsed.id;
    //   this.variantDetail = parsed;
    // },
    // init() {
    //   let defaultOption = this.$el.querySelector("option:checked").value;
    //   this.selectedVariantDetail = defaultOption;
    //   this.propagateData();
    // },
  }));

  Alpine.data("productCardSwatch", () => ({
    // selectedVariantDetail: "{}",
    // propagateData() {
    //   let parsed = JSON.parse(this.selectedVariantDetail);
    //   this.selectedVariant = parsed.id;
    //   this.variantDetail = parsed;
    // },
    // init() {
    //   let defaultOption = this.$el.querySelector("input:checked")?.value;
    //   if (!defaultOption) return;
    //   this.selectedVariantDetail = defaultOption;
    //   this.propagateData();
    // },
  }));

  Alpine.data("collection", (sectionId, sortBy, view) => ({
    collection: {
      filters: {
         sort_by: [sortBy],
         view: [view],
         q: undefined
      },
      sectionId: sectionId
    },
    init() {
      let searchTerms = this.$refs.searchTerms ? this.$refs.searchTerms.text : null;
      this.collection.filters.q = searchTerms ? [this.decodeHtmlEntities(searchTerms)] : [] ;
    },
    onFiltersUpdated() {
      this.$nextTick(() => {

      });
      setTimeout(() => {
        this.submit(this.collection.filters);
        this.updateUrl(this.collection.filters);
      }, 0);
    },
    async submit(formAction) {
      const queryString = this.serializeQuery(formAction);

      const url = window.location.pathname + "?" + queryString + '&section_id=' + this.collection.sectionId;

      this.global.loading = true;
      const r = await fetch(url);
      const html = await r.text();
      setTimeout(() => {
        this.global.loading = false;
      }, 750);
      

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      let productGrid = doc.getElementById('product-grid');
      let collectionFilters = doc.getElementById('collection-filters');

      this.$refs.productGrid.innerHTML = productGrid.innerHTML;
      this.$refs.sidebar.innerHTML = collectionFilters.innerHTML;
    },
    serializeQuery(obj) {
      const params = [];

      for (const key in obj) {
          if (Array.isArray(obj[key])) {
              obj[key].forEach(value => {
                  if (value !== "") {
                      params.push(`${key}=${encodeURIComponent(value)}`);
                  }
              });
          } else if (obj[key] !== "" && obj[key].length > 0) {
              params.push(`${key}=${encodeURIComponent(obj[key])}`);
          }
      }
  
      return params.join('&');
    },
    updateUrl(formAction) {
      const queryString = this.serializeQuery(formAction);
      newUrl = window.location.pathname + '?' + queryString;
      window.history.pushState('', '', newUrl);
    }
  })); 


  Alpine.data("searchPage", (sectionId, sortBy, view) => ({
    searchPage: {
      filters: {
         sort_by: [sortBy],
         view: [view]
      },
      sectionId: sectionId
    },
    init() {

    },
    onFiltersUpdated() {
      this.$nextTick(() => {

      });
      setTimeout(() => {
        this.submit(this.searchPage.filters);
        this.updateUrl(this.searchPage.filters);
      }, 0);
    },
    async submit(formAction) {
      const queryString = this.serializeQuery(formAction);

      const url = window.location.pathname + "?" + queryString + '&section_id=' + this.searchPage.sectionId;

      this.global.loading = true;
      const r = await fetch(url);
      const html = await r.text();
      setTimeout(() => {
        this.global.loading = false;
      }, 750);
      

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      let productGrid = doc.getElementById('product-grid');
      let collectionFilters = doc.getElementById('collection-filters');

      this.$refs.productGrid.innerHTML = productGrid.innerHTML;
      this.$refs.sidebar.innerHTML = collectionFilters.innerHTML;
    },
    serializeQuery(obj) {
      const params = [];

      for (const key in obj) {
          if (Array.isArray(obj[key])) {
              obj[key].forEach(value => {
                  if (value !== "") {
                      params.push(`${key}=${encodeURIComponent(value)}`);
                  }
              });
          } else if (obj[key] !== "" && obj[key].length > 0) {
              params.push(`${key}=${encodeURIComponent(obj[key])}`);
          }
      }
  
      return params.join('&');
    },
    updateUrl(formAction) {
      const queryString = this.serializeQuery(formAction);
      newUrl = window.location.pathname + '?' + queryString;
      window.history.pushState('', '', newUrl);
    }
  })); 


  Alpine.data("sidebarFilter", () => ({
    sidebarFilter: {
      filters: null,
    },
    init() {
      this.sidebarFilter.filters = JSON.parse(this.$refs.sidebarData.text);
      this.sidebarFilter.filters.forEach(x => {
        let activeValues = x.filter.active_values.map(x => x.value);
        let allValues = x.filter.values.map(x => x.value);
        let first6 = allValues.slice(0, 6);
        x.expanded = activeValues.filter(item => !first6.includes(item)).length > 0;
      });
      this.processFilters(this.sidebarFilter.filters);
    },
    processFilters(input) {
      input.forEach(filterGroup => {
        const { param_name, active_values, type, min_value, max_value } = filterGroup.filter;
    
        if (type == 'price_range') {
          this.collection.filters['filter.v.price.gte'] = min_value != null ? [ (min_value / 100) ] : [];
          this.collection.filters['filter.v.price.lte'] = max_value != null ? [ (max_value / 100) ] : [];
        }
        else if (active_values && active_values.length > 0) {
          const values = active_values.map(val => this.decodeHtmlEntities(val.value));
    
          this.collection.filters[param_name] = values;
        } 
        else {
          this.collection.filters[param_name] = [];
        }
      });

      
      
    },
    applyFilter() {
      this.$nextTick(() => {
        this.$dispatch('filters-updated');
      });
    },
  }));
  Alpine.data("priceRangeSlider", () => ({
    priceRangeSlider: { 
        slider: null,
        min: 0,
        max: 80
    },
    init() {
      this.priceRangeSlider.slider = this.$refs.slider;
      if (!this.priceRangeSlider.slider.noUiSlider) {
        
        noUiSlider.create(this.priceRangeSlider.slider, {
          start: [0, 80],
          step: 1,
          connect: true,
          tooltips: {
                    to: function(value) {
                      if (value >= 80) {
                        return '$80+';
                      }
                      return '$' + Math.round(value);
                    },
                  },
          margin: 1,
          range: {
              'min': 0,
              'max': 80
          }
        });
      }


      this.manuallySetValues(this.collection.filters['filter.v.price.gte'], this.collection.filters['filter.v.price.lte']);

      this.priceRangeSlider.slider.noUiSlider.on('update', function (values) {
        var min = Number(values[0]);
        var max = Number(values[1]);
        this.priceRangeSlider.min = min;
        this.priceRangeSlider.max = max >= 80 ? '80+' : max;
        this.collection.filters['filter.v.price.gte'] = min == 0 ? [] : [min.toString()];
        this.collection.filters['filter.v.price.lte'] = max >= 80 ? [] : [max.toString()];
      }.bind(this));

    },
    manuallySetValues(gte, lte) {
      let min = 0;
      let max = 80;

      if (gte.length) {
        min = Number(gte[0]);
      }
      if (lte.length) {
        max = Number(lte[0]);
      }
      this.priceRangeSlider.slider.noUiSlider.set([min, max]);
    }
  }));
  //has productCards as children
  Alpine.data("bundleProduct", () => ({
    productCount: null,
    showPrice: false,
    selectedVariants: [],
    bundleTier: null,
    bundleTitle: null,
    bundleCode: null,
    bundleItemIds: null,
    purchaseQuantity: 1,
    isAddingToCart: false,
    adjustedPrice: null,
    originalPrice: null,
    priceDiff: null,

    init() {
      let data = JSON.parse(this.$refs.data.text);
      this.productCount = data.productCount;
      this.bundleTier = data.bundleTier;
      this.bundleCode = data.bundleCode;
      this.bundleItemIds = data.bundleItemIds;
      this.bundleTitle = data.bundleTitle;
    },
    onVariantSelected: {
      ["@variant-selected-from-bundle"](event) {
        let updatedSelectedVariant = event.detail;

        let productIds = this.selectedVariants.map((x) => x.product.id);
        let existingSelectedVariantIndex = this.selectedVariants.findIndex(
          (x) => x.product.id == updatedSelectedVariant.product.id
        );
        if (existingSelectedVariantIndex >= 0) {
          this.selectedVariants[existingSelectedVariantIndex] =
            updatedSelectedVariant;
        } else {
          this.selectedVariants.push(updatedSelectedVariant);
        }

        if (this.selectedVariants.length < this.productCount) return;
        let originalPriceNum = this.selectedVariants.reduce((a, b) => {
          return a + b.price;
        }, 0);
        let adjustedPriceNum = originalPriceNum * (1 - this.bundleTier / 100);
        let priceDiffNum = originalPriceNum - adjustedPriceNum;

        this.adjustedPrice = Shopify.formatMoney(adjustedPriceNum).replace(
          "$",
          ""
        );
        this.originalPrice = Shopify.formatMoney(originalPriceNum).replace(
          "$",
          ""
        );
        this.priceDiff = Shopify.formatMoney(priceDiffNum).replace("$", "");

        this.showPrice = true;
      },
    },
    onBuyButtonClick: {
      ["@click.prevent"]() {
        this.isAddingToCart = true;
        let properties = {};

        let payload = this.selectedVariants.map((x) => ({
          variantId: x.id,
          quantity: this.purchaseQuantity,
          isPreorder: x.isPreorder,
          isBackorder: x.isBackorder,
          properties: {
            Bundle: this.bundleTitle,
            _BundleItems: this.bundleItemIds.toString(),
            _BundleTier: this.bundleTier,
            _BundleCode: this.bundleCode,
          },
        }));
        addBatchToCartAsync(payload, () => {
          this.isAddingToCart = false;
        });
      },
    },
  }));
});
